import React, { useState } from 'react'
import { toast } from 'react-toastify'

import Modal from '@mui/material/Modal'
import Card from '@mui/material/Card'
import Box from '@mui/material/Box'
import { TextField } from '@mui/material'
import { privateToAddress } from 'ethereumjs-util'

import SectionTitle from '../../../../components/kit/SectionTitle'
import { useAirdropDispatch } from '../../../../contexts/airDropContext'
import { storeSigner, storeInitiatorAddress } from '../../../../contexts/airdropActionCreators'
import Button from 'src/ui/atoms/Button'

const Buffer = window.Buffer
const PrivateKeyModal = ({
  showPrivateKeyModal,
  togglePrivateKeyModal,
}: {
  showPrivateKeyModal: boolean
  togglePrivateKeyModal: () => void
}) => {
  const [privateKey, setPrivateKey] = useState<string>('')

  const dispatchAirdropAction = useAirdropDispatch()

  const isValidPrivateKey = () => {
    return true
  }

  const handleCloseModal = () => {
    togglePrivateKeyModal()
    setPrivateKey('')
  }

  const handleClickConnect = () => {
    try {
      const address = '0x' + privateToAddress(Buffer.from(privateKey, 'hex')).toString('hex')
      storeInitiatorAddress(dispatchAirdropAction, address)
      storeSigner(dispatchAirdropAction, privateKey)

      handleCloseModal()
    } catch (e) {
      console.error('error in creating signer', e)
      toast.error('Invalid private key')
    }
  }

  return (
    <Modal
      open={showPrivateKeyModal}
      onClose={handleCloseModal}
      aria-labelledby="confirm-modal"
      aria-describedby="confirm-remove-modal">
      <Card
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minHeight: '300px',
          maxHeight: '90%',
          width: '600px',
          maxWidth: '90%',
          background: '#181D38',
          color: '#fff',
          borderRadius: '16px',
        }}>
        <Box
          sx={{
            width: '100%',
            height: '100%',
            minHeight: '300px',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            borderRadius: '8px',
            boxSizing: 'border-box',
            padding: '24px',
          }}>
          <SectionTitle title="Enter your wallet private key in the field below" />
          <Box
            mt={4}
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              flexDirection: 'column',
              width: '100%',
            }}>
            <TextField
              id="mnemonic-text-field"
              label="Private Key"
              multiline
              minRows={3}
              value={privateKey}
              onChange={(e) => setPrivateKey(e.target.value)}
              sx={{
                '& label': {
                  color: '#fff',
                  fontFamily: 'SpaceGrotesk, sans-serif',

                  '&.Mui-focused': {
                    color: '#fff',
                  },
                },

                '& .MuiOutlinedInput-root': {
                  color: '#fff',
                  fontFamily: 'SpaceGrotesk, sans-serif',

                  '&:hover fieldset': {
                    borderColor: '#fff',
                  },
                },

                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#fff',
                  color: '#fff',

                  '&.Mui-focused': {
                    borderColor: '#fff',
                    color: '#fff',
                  },
                },
              }}
            />
          </Box>
          <Box
            mt={4}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'row',
              width: '100%',
              gap: '40px',
            }}>
            <Button name="Cancel" size="M" onClick={handleCloseModal} type="secondary" />
            <Button
              name="Connect"
              disabled={!privateKey || !isValidPrivateKey}
              size="M"
              onClick={handleClickConnect}
              type="primary"
            />
          </Box>
        </Box>
      </Card>
    </Modal>
  )
}

export default PrivateKeyModal
